import React, { useState } from 'react';
import { TextField, Typography, Grid } from '@material-ui/core';
import { Link, useHistory } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles';
import { toast } from 'react-toastify';
import AuthorizationClient from '../single-page/api/AuthorizationClient'
import LoadingButton from '../components/LoadingButton.js'

const useStyles = makeStyles((theme) => ({
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
    borderRadius: '31px',
    border: '1px solid #6600CB',
    padding: '32px',
    backgroundColor: '#1A3F1B',
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  paper: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    alignItems: 'center',
  },
  link: { 
    color: '#D2B5FF',
    textDecoration: 'none'
  }
}));

export default function RequestPasswordReset() {
  const classes = useStyles();
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  
  function requestPasswordReset(e) {
    e.preventDefault();
    document.activeElement.blur();
    
    setLoading(true);
    AuthorizationClient.requestPasswordReset({ email: email })
      .then(function(res){
        toast.success('Olhe sua caixa de e-mail para concluir o processo');
        history.push("/public/sign_in");
      })
      .catch(function(response){
        if (response.status == 422){
          setEmailError(response.data.errors.email.join(', '));
        } else {
          setEmailError();
        }
      })
      .then(function() {
        setLoading(false);
      });
  }

  return (
    <div className={classes.paper}>
      <Typography component="h1" variant="h5">
        Recuperar minha senha
      </Typography>
      <form className={classes.form} onSubmit={requestPasswordReset} noValidate>
        <TextField
          required
          id="email"
          label="Email"
          name="email"
          fullWidth={true}
          value={email}
          error={emailError}
          helperText={emailError}
          onChange={(e) => setEmail(e.target.value)}
          autoComplete='email'
          autoFocus
        />

        <LoadingButton
          type="submit"
          fullWidth
          loading={loading}
          variant="contained"
          color="primary"
          className={classes.submit}
        >
          ENVIAR
        </LoadingButton>
      </form>
      <Grid container style={{ display: 'flex', flexDirection: 'column' }}>
        <Grid style={{ padding: '20px 20px 10px 20px' }} item xs>
          <Link className={classes.link} variant="body2" to="/public/sign_in">
            Entrar
          </Link>
        </Grid>
        <Grid style={{ padding: '0px 20px' }} item>
          <Link className={classes.link} variant="body2" to="/public/sign_in">
            Não possui uma conta? Cadastre-se
          </Link>
        </Grid>
      </Grid>
    </div>
  );
}